import React, { FC } from 'react';

import { BLOCKS } from '~/src/features/movix-new/BlocksAbout/data';

import * as ST from './styled';

const BlocksAbout: FC = () => {
    return (
        <ST.BlocksContainer>
            {BLOCKS.map(({ title, description }) => (
                <ST.Block key={title}>
                    <ST.Title>{title}</ST.Title>
                    <ST.Description>{description}</ST.Description>
                </ST.Block>
            ))}
        </ST.BlocksContainer>
    );
};

export default BlocksAbout;
